import {genqlBuilder} from "@/core/graphql/genql/builder"

import {MutationGenqlSelection, VorderSubmitResult} from "../schema"

import {MutationVorderSubmitArgs} from "../schema"

export type MutationVorderSubmitVars = MutationVorderSubmitArgs

export function vorderSubmitMutation(mutation: MutationGenqlSelection['vorder_submit'] | null) {            
    return {
      build: (variables: MutationVorderSubmitVars) => genqlBuilder.build(mutation ? {vorder_submit: mutation} : {__scalar: true}, {vorder_submit: variables}),  
      mutate: (variables: MutationVorderSubmitVars) => ({} as Promise<VorderSubmitResult>),
      _variables: {} as MutationVorderSubmitVars,
      _result: {} as VorderSubmitResult,
    }
}

export type MutationVorderSubmit = {
  builder: (variables: MutationVorderSubmitVars) => MutationGenqlSelection,
  selection: MutationGenqlSelection['vorder_submit'],
  variables: MutationVorderSubmitVars,
  result: VorderSubmitResult
}

export default vorderSubmitMutation